const links = [
  {
    label: "Home",
    url: "/",
  }
]

export default links
